import React, { useEffect } from "react";

const RecoModal = ({ suggestions, onSelect, onClose }) => {
  useEffect(() => {
    const handler = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [onClose]);

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.4)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "white",
          borderRadius: 8,
          maxWidth: 480,
          width: "90%",
          maxHeight: "80vh",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
        }}
      >
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "12px 16px",
          borderBottom: "1px solid #e5e7eb",
        }}>
          <span style={{ fontWeight: 600, fontSize: 14, color: "#1f2937" }}>
            Suggestions fréquentes
          </span>
          <button
            type="button"
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              fontSize: 18,
              color: "#6b7280",
              lineHeight: 1,
              padding: "0 4px",
            }}
          >
            ×
          </button>
        </div>
        <div style={{ overflowY: "auto", flex: 1 }}>
          {suggestions.map((s, i) => (
            <button
              key={i}
              type="button"
              dir={/[؀-ۿ]/.test(s.text.charAt(0)) ? "rtl" : "ltr"}
              onClick={() => onSelect(s.text)}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                padding: "9px 16px",
                background: "none",
                border: "none",
                borderBottom: "1px solid #f3f4f6",
                cursor: "pointer",
                textAlign: "left",
                fontSize: 13,
                fontWeight: 500,
                color: "#1f2937",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.background = "#fef9c3"; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = "none"; }}
            >
              <span>{s.text}</span>
              <span style={{ color: "#9ca3af", fontSize: 11, marginLeft: 8, whiteSpace: "nowrap" }}>
                · {s.freq}
              </span>
            </button>
          ))}
        </div>
        <div style={{
          padding: "8px 16px",
          borderTop: "1px solid #e5e7eb",
          fontSize: 11,
          color: "#9ca3af",
          textAlign: "center",
        }}>
          Basé sur les recommandations les plus fréquemment utilisées dans les carnets.
        </div>
      </div>
    </div>
  );
};

export default RecoModal;
